import { DarkMode, LightMode, VolumeOff, VolumeUp } from '@mui/icons-material';
import { Box, IconButton } from '@mui/material';
import { useContent } from 'contexts/Content/Content';
import { useSounds } from 'contexts/Sounds/Sounds';
import { useTheme } from 'contexts/Theme/Theme';

export default function HeaderControls() {
    const content = useContent();
    const sounds = useSounds();
    const theme = useTheme();

    function handleColorSchemeClick() {
        theme.setColorScheme(theme.darkMode ? 'light' : 'dark');
    }

    const color = content.header.foreground || '#FAAD19';

    return (
        <>
            <Box color={sounds.muted ? '#AEAEAE' : color}>
                <IconButton
                    aria-label={sounds.muted ? 'Unmute' : 'Mute'}
                    color="inherit"
                    data-testid="header-control-mute"
                    onClick={() => sounds.setMuted(!sounds.muted)}
                >
                    {sounds.muted ? <VolumeOff /> : <VolumeUp />}
                </IconButton>
            </Box>
            <Box color={color}>
                <IconButton
                    aria-label={theme.darkMode ? 'Switch to light mode' : 'Switch to dark mode'}
                    color="inherit"
                    data-testid="header-control-theme"
                    onClick={handleColorSchemeClick}
                >
                    {theme.darkMode ? <DarkMode /> : <LightMode />}
                </IconButton>
            </Box>
        </>
    );
}
